<template>
  <div class="button-wrap">
    <!-- <el-button type="danger" size="small" @click="handleFn('hot')" v-if="showHot" :disabled="checkIds.length<1">设为热门</el-button>
    <el-button type="primary" size="small" @click="handleFn('add')">新增</el-button>
    <el-button type="warning" v-if="showSoldout" size="small" @click="handleFn('soldOut')" :disabled="checkIds.length<1">下架</el-button>
    <el-button type="danger" size="small" @click="handleFn('delete')" :disabled="checkIds.length<1">删除</el-button> -->
    <el-button
      type="danger"
      size="small"
      @click.stop="handleFn('hot')"
      v-if="showHot"
      :disabled="checkData.length < 1"
      >设为热门</el-button
    >
    <el-button type="primary" size="small" @click.stop="handleFn('add')"
      >新增</el-button
    >
    <el-button
      type="warning"
      v-if="showSoldout"
      size="small"
      @click.stop="handleFn('soldOut')"
      :disabled="checkData.length < 1"
      >下架</el-button
    >
    <el-button
      type="danger"
      size="small"
      @click.stop="handleFn('delete')"
      v-if="showDelete"
      :disabled="checkData.length < 1"
      >删除</el-button
    >
    <slot></slot>
  </div>
</template>

<script>
/* eslint-disable */
import { api, confirm } from "@/utils";
export default {
  data() {
    return {
      checkIds: [],
    };
  },
  props: {
    showHot: {
      type: Boolean,
      default: false,
    },
    checkData: {
      type: Array,
      default() {
        return [];
      },
    },
    module: {
      type: Number,
      default: null,
    },
    showSoldout: {
      type: Boolean,
      default: true,
    },
    showDelete: {
      type: Boolean,
      default: true,
    },
    isEntranceClass: {
      type: Boolean,
      default: false,
    },
    isAppletZhuanti: {
      type: Boolean,
      default: false,
    },
    isAppletArticle: {
      type: Boolean,
      default: false,
    },
    isArticleYanxue: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleFn(type) {
      console.log(type)
      let { name } = this.$route;
      let path = name.split("-")[0];
      console.log(this.isArticleYanxue,path,'path');
      if (type === "add") {
        console.log(this.isEntranceClass, this.isAppletArticle);
        if (this.isEntranceClass) {
          this.toState({
            name: path + "2",
            params: { type: "add" },
            query: { moduleId: this.module },
          });
        } else if (this.isAppletArticle) {
          this.toState({
            name: path + "3",
            params: { type: "add" },
            query: { moduleId: this.module },
          });
        } else if (this.isArticleYanxue) {
          this.toState({
            name: path + "4",
            params: { type: "add" },
            query: { moduleId: this.module },
          });
        } else {
          if (this.module == 7) {
            this.toState({
              name: path,
              params: { type: "add" },
              query: { moduleIdSxkt: this.module },
            });
          } else {
            this.toState({
              name: path,
              params: { type: "add" },
              query: { moduleId: this.module },
            });
          }
        }
      } else {
        let url;
        let txt;
        if (type === "delete") {
          if (path == "shengxue/banner") {
            url = api[`zhiyuan/bannerDelete`];
          } else {
            url = api[`${path}Delete`];
          }
          txt = "删除";
        } else if (type === "soldOut") {
          if (this.isEntranceClass) {
            url = api[`${path}EntranceClass`];
          } else if (this.isAppletZhuanti) {
            url = api.setSpecialTopicStatus;
          } else if (this.isAppletArticle || this.isArticleYanxue) {
            url = api.setArticleStatus;
          } else {
            if (path == "shengxue/banner") {
              url = api[`zhiyuan/bannerSoldOut`];
            } else {
              url = api[`${path}SoldOut`];
            }
          }
          txt = "下架";
        } else if (type === "hot") {
          url = api[`${path}Hot`];
          txt = "设为热门";
        }
        console.log(txt,url)
        confirm(`您确定将选择的内容${txt}吗？`, "提示").then(() => {
          this.checkIds = [];
          // this.lodash.map(this.checkData, (item) => {
          for (let item = 0; item < this.checkData.length; item++) {
            if (txt === "下架") {
              if (
                this.checkData[item].status === 2 ||
                this.checkData[item].status === 3
              ) {
                this.$message.error(`已下架或草稿状态的内容不能${txt}`);
                this.checkIds = [];
                return;
              } else {
                this.checkIds.push(this.checkData[item].id);
              }
            } else if (txt === "删除") {
              if (this.checkData[item].status === 1) {
                this.$message.error(`已发布的内容不能${txt}`);
                this.checkIds = [];
                return;
              } else {
                this.checkIds.push(this.checkData[item].id);
              }
            } else {
              this.checkIds.push(this.checkData[item].id);
            }
          }
          if (this.checkIds.length > 0) {
            this.$fly
              .post(url, this.checkIds)
              .then((data) => {
                this.$message({
                  message: `${txt}成功`,
                  duration: 2000,
                  type: "success",
                });
                this.$emit("refresh");
                //  this.getData(this.params)
              })
              .catch(() => {
                this.$message({
                  message: `${txt}失败`,
                  duration: 2000,
                  type: "error",
                });
              });
          }
        });
      }
    },
  },
  beforeMount() {
    // console.log(this.$route)
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/list-handle.vue